import PhoneIcon from './component'

export default PhoneIcon
